'use strict';

var styled = require('styled-components');
var theme = require('../../theme/theme.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const DEFAULT_PILL_BACKGROUND_COLOR = theme.theme.colors.body.text;
const PILL_BACKGROUND_COLORS = {
    primary: theme.theme.colors.primary.normal,
    success: theme.theme.colors.success.normal,
    warning: theme.theme.colors.warning.normal,
    danger: theme.theme.colors.danger.normal,
    grey: theme.theme.colors.disabled.text,
    dark: DEFAULT_PILL_BACKGROUND_COLOR,
};
const getBackgroundColor = ({ color }) => PILL_BACKGROUND_COLORS[color] || DEFAULT_PILL_BACKGROUND_COLOR;
const DEFAULT_PILL_SIZE = '10px';
const PILL_SIZES = {
    s: DEFAULT_PILL_SIZE,
    m: '16px',
    l: '20px',
    xl: '24px',
};
const getSize = ({ size }) => PILL_SIZES[size] || DEFAULT_PILL_SIZE;
const PillStyled = styled__default.default.span `
  width: ${getSize};
  height: ${getSize};
  border-radius: 50%;
  background-color: ${getBackgroundColor};
`;
const PillContainer = styled__default.default.div `
  display: inline-flex;
  justify-content: center;
  padding-inline: 5px;
`;

exports.PILL_SIZES = PILL_SIZES;
exports.PillContainer = PillContainer;
exports.PillStyled = PillStyled;
exports.getBackgroundColor = getBackgroundColor;
exports.getSize = getSize;
//# sourceMappingURL=pill.styles.js.map
